
/*
 * ! @chakra-ui/vue v0.11.0 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import { R as createStyledAttrsMixin } from './index-4e48fa90.js';
import './chakra-ui-styled-system.esm-b7ad2a27.js';
import '@emotion/css';
import 'vue';
import './color-mode-observer-14d12060.js';
import { u as useTruncated } from './text.utils-f22d6933.js';

/**
 * Hey! Welcome to @chakra-ui/vue Text
 *
 * Text is the used to render text and paragraphs within an interface. It renders a <p> tag by default.
 *
 * @see Docs     https://vue.chakra-ui.com/text
 * @see Source   https://github.com/chakra-ui/chakra-ui-vue/blob/master/packages/chakra-ui-core/src/CText/CText.js
 */
/**
 * CText component
 *
 * the text element component
 *
 * @see Docs https://vue.chakra-ui.com/text
 */

var CText = {
  name: 'CText',
  mixins: [createStyledAttrsMixin('CText')],
  props: {
    as: {
      type: [String, Array],
      default: 'p'
    },
    isTruncated: Boolean,
    fontFamily: {
      type: [String, Array],
      default: 'body'
    }
  },
  computed: {
    componentStyles: function componentStyles() {
      return Object.assign({}, {
        fontFamily: this.as === 'kbd' ? 'mono' : this.fontFamily
      }, this.isTruncated && useTruncated());
    }
  },
  render: function render(h) {
    return h(this.as, {
      class: this.className,
      attrs: this.computedAttrs
    }, this.$slots.default);
  }
};

export default CText;
